export default __webpack_public_path__ + "static/media/tafida.66aedd23.JPG";